/**
 * Called after a new Group is selected in the folder forest
 */
import { action } from 'satcheljs';
import { orchestrator } from 'satcheljs';
import commandBarStore from 'owa-group-header-store/lib/store/CommandBarStore';
import { getCurrentGroupSmtpAddress } from 'owa-groups-shared-store';
import NavigationButton from 'owa-group-header-store/lib/store/schema/NavigationButton';
import { lazyOnFilesNavigationAction } from 'owa-group-fileshub-actions';
import { isConsumer } from 'owa-session-store';
import { lazyOnFilesViewNavigation } from 'owa-files-view';

export const onAfterNewGroupSelected = action(
    'onAfterNewGroupSelected',
    (groupSmtpAddress: string) => ({
        groupSmtpAddress: groupSmtpAddress,
    })
);

orchestrator(onAfterNewGroupSelected, async msg => {
    if (commandBarStore.navigationButtonSelected == NavigationButton.Files) {
        if (msg.groupSmtpAddress.toLowerCase() == getCurrentGroupSmtpAddress().toLowerCase()) {
            if (isConsumer()) {
                lazyOnFilesViewNavigation.importAndExecute('ConsumerGroupFilesHub');
            } else {
                lazyOnFilesNavigationAction.importAndExecute();
            }
        }
    }
});
